module.exports = __webpack_public_path__ + "static/media/il.3399f8f9.svg";